export const DEVICE_TYPE_MOBILE = 'm';
export const DEVICE_TYPE_TABLET = 't';
export const DEVICE_TYPE_DESKTOP = 'd';
export const SCREEN_ORIENTATION_PORTRAIT = 'portrait';
export const SCREEN_ORIENTATION_LANDSCAPE = 'landscape';